'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setFilterExpression = exports.publish = exports.hereNow = exports.subscribe = exports.disconnect = exports.connect = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _pubnub = require('pubnub');

var _pubnub2 = _interopRequireDefault(_pubnub);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var connection = void 0;

var messageSubscriptons = new _set2.default();
var presenceSubscriptions = new _set2.default();
var statusSubscriptions = new _set2.default();

var connect = exports.connect = function connect(publishKey, pubnubId, subscribeKey) {
    if (connection && !publishKey) {
        return connection;
    }

    connection = new _promise2.default(function (resolve, reject) {
        var options = {
            publishKey: publishKey ? publishKey : '',
            subscribeKey: subscribeKey,
            uuid: pubnubId
        };

        var pubnub = new _pubnub2.default(options);

        var initialHandler = {
            status: function status(statusEvent) {
                switch (statusEvent.category) {
                    case 'PNConnectedCategory':
                    case 'PNNetworkUpCategory':
                        resolve(pubnub);
                        break;
                    case 'PNDisconnectedCategory':
                    case 'PNNetworkDownCategory':
                        reject(new Error('Received a network-down message'));
                        break;
                    default:
                        return;
                }

                pubnub.removeListener(initialHandler);

                pubnub.addListener({
                    message: function message() {
                        var _arguments = arguments;

                        messageSubscriptons.forEach(function (handler) {
                            return handler.apply(undefined, _arguments);
                        });
                    },
                    presence: function presence() {
                        var _arguments2 = arguments;

                        presenceSubscriptions.forEach(function (handler) {
                            return handler.apply(undefined, _arguments2);
                        });
                    },
                    status: function status() {
                        var _arguments3 = arguments;

                        statusSubscriptions.forEach(function (handler) {
                            return handler.apply(undefined, _arguments3);
                        });
                    }
                    // status: statusEvent => {
                    //     switch (statusEvent.category) {
                    //         case 'PNDisconnectedCategory':
                    //         case 'PNNetworkDownCategory':
                    //             connect(); // reconnect
                    //             break;
                    //     }
                    // },
                });
            }
        };

        pubnub.addListener(initialHandler);

        return handshake(pubnub).then(function () {
            return resolve({ pubnub: pubnub, uuid: pubnubId });
        }).catch(reject);
    });

    return connection;
};

var disconnect = exports.disconnect = function disconnect() {
    return connect().then(function (_ref) {
        var pubnub = _ref.pubnub;
        return pubnub.stop();
    });
};

var handshake = function handshake(pubnub) {
    return new _promise2.default(function (resolve, reject) {
        pubnub.time(function (status) {
            if (status.error) {
                reject(new Error('PubNub service failed to respond to time request: ' + status.error));
            } else {
                resolve(pubnub);
            }
        });
    });
};

var subscribe = exports.subscribe = function subscribe(channel, presenceHandler, messageHandler, statusHandler) {
    messageSubscriptons.add(messageHandler);
    presenceSubscriptions.add(presenceHandler);
    statusSubscriptions.add(statusHandler);

    connect().then(function (_ref2) {
        var pubnub = _ref2.pubnub;

        pubnub.subscribe({
            channels: [channel],
            withPresence: true
        });
    });

    return {
        unsubscribe: function unsubscribe() {
            messageSubscriptons.delete(messageHandler);
            presenceSubscriptions.delete(presenceHandler);
            statusSubscriptions.delete(statusHandler);

            return connect().then(function (_ref3) {
                var pubnub = _ref3.pubnub;

                pubnub.unsubscribe({ channels: [channel] });
            });
        }
    };
};

var hereNow = exports.hereNow = function hereNow(channel) {
    return new _promise2.default(function (resolve, reject) {
        connect().then(function (_ref4) {
            var pubnub = _ref4.pubnub;
            return pubnub.hereNow({
                channels: [channel],
                includeState: false,
                includeUUIDs: false
            }, function (status, response) {
                if (status.error) {
                    reject(status.category);
                } else {
                    resolve(response);
                }
            });
        });
    });
};

var publish = exports.publish = function publish(channel, message) {
    return new _promise2.default(function (resolve, reject) {
        connect().then(function (_ref5) {
            var pubnub = _ref5.pubnub;
            return pubnub.publish({
                channel: channel,
                message: message
            }, function (status) {
                if (status.error) {
                    reject(status.category);
                } else {
                    resolve();
                }
            });
        });
    });
};

var setFilterExpression = exports.setFilterExpression = function setFilterExpression(filterExpression) {
    return new _promise2.default(function (resolve, reject) {
        connect().then(function (_ref6) {
            var pubnub = _ref6.pubnub;

            pubnub.setFilterExpression(filterExpression);
            resolve();
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/services/pubnubService.js
// module id = bhSj
// module chunks = 60